import * as React from 'react';
import { Rate as DesignRate } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/FormItem';

const Rate = ({ element, elementStyle }) => {
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  return (
    <FormItem
      id={element.id}
      style={{
        ...elementStyle,
        visibility: visible
      }}
      {...formSettings}
    >
      <DesignRate {...formItemSettings} className={className} />
    </FormItem>
  );
};

export default Rate;
